// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gUvEDovDlkU8aw5Cs7V0{gap:8px}.gUvEDovDlkU8aw5Cs7V0>div{align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `gUvEDovDlkU8aw5Cs7V0`
};
export default ___CSS_LOADER_EXPORT___;
